module.exports = "/_next/static/images/Privacy-md@2x-55c795c125c7aab1c7b92eee95cbb858.png";